// @ts-nocheck: converted from JS

import ColonyAddToStudy from '@/components/Colony/Add';

export default ColonyAddToStudy;
